module.exports = __webpack_public_path__ + "img/P2.d722104.png";